interface ValueMapBoxProps {
  title: string;
  content: string;
  color: 'orange' | 'red' | 'green';
  icon?: string;
}

const colorClasses = {
  orange: {
    border: 'border-cloudflare-orange',
    bg: 'bg-orange-50',
    title: 'text-cloudflare-orange',
  },
  red: {
    border: 'border-red-500',
    bg: 'bg-red-50',
    title: 'text-red-600',
  },
  green: {
    border: 'border-green-500',
    bg: 'bg-green-50',
    title: 'text-green-600',
  },
};

export default function ValueMapBox({ title, content, color, icon }: ValueMapBoxProps) {
  const colors = colorClasses[color];

  return (
    <div
      className={`
        border-4 rounded-xl p-6 shadow-md
        ${colors.border} ${colors.bg}
        transition-all duration-200 hover:shadow-lg
      `}
    >
      <div className="flex items-center gap-3 mb-4">
        {icon && <span className="text-3xl">{icon}</span>}
        <h3 className={`text-xl font-bold ${colors.title}`}>{title}</h3>
      </div>
      <p className="text-gray-800 leading-relaxed text-base">{content}</p>
    </div>
  );
}
